<template>
  <el-dialog :close-on-click-modal="false" :show="show" :visible="visible" title="视频维护"
             width="45%"
             @close="close" custom-class="module-dialog">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="detail-form-content" label-width="120px">
      <el-form-item class="input" label="视频标题" prop="videoName">
        <el-input v-model="ruleForm.videoName" autocomplete="off" placeholder="请输入视频标题"/>

      </el-form-item>
      <el-form-item class="input" label="视频" prop="videoUrl">
        <el-upload
            ref="upload"
            :action="fileUploadUrl"
            :file-list="fileList"
            :multiple="false"
            :headers="myHeaders"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            list-type="picture-card"
            
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
        <el-button v-show="updateBtn" class="btn" type="primary" @click="commit()">保存</el-button>
        <el-button class="btn close" @click="close()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import base from '../../../utils/base'

export default {
  name: 'addOrUpdate',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mounted(){
    this.myHeaders= {
      'Token':this.$storage.get("Token")
    }
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        window.vm = this;
      }
    },
    rowData() {
      this.$http({
        url: "baseVideo/info/" + this.rowData.id,
        method: "get",
      }).then(({data}) => {
        if (data.data != null) {
          this.ruleForm = data.data;
        }
      });
      if (this.rowData.type === 'info') {
        this.updateBtn = false;
      }
    },
  },
  data() {
    return {
      updateBtn: true,
      url: base.get().url,
      fileUploadUrl: base.get().fileUploadUrl,
      visible: false,
      ruleForm: {
        videoName: '',
        videoUrl: '',
        id: ''
      },
      rules: {
        videoName: [{required: true, message: '请输入视频标题', trigger: 'blur'}],
        videoUrl: [{required: true, message: '请输入视频地址', trigger: 'blur'}],
      },
      fileList: [],
      myHeaders: {
        'Token': this.$storage.get("Token")
      },
    }
  },
  methods: {
    close() {
      this.updateBtn = true;
      this.$refs['ruleForm'].resetFields();
      this.$emit("listenToChildEvent", false);
    },
    commit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.ruleForm.id === '' || this.ruleForm.id === undefined ? this.url + `baseVideo/` + "save" : this.url + `baseVideo/` + "update",
            method: "post",
            data: this.ruleForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.close();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 上传文件成功后执行
    handleUploadSuccess(res, file, fileList) {
      this.ruleForm.videoUrl = file.response.file;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传${this.limit}个视频`);
    },
  }
}
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>